import React from "react";
import PropTypes from "prop-types";

const Actions = ({ edit, loading, onToggle, onDelete, onSave }) =>
  edit 
  ? [

      <button
        key="save"
        className="btn btn-text"
        disabled={loading}
        onClick={onSave}
        onKeyDown={(e) => e.key === "Enter" && onSave()}
      >
        SAVE
      </button>,
      <button
        key="cancel"
        className="btn btn-text"
        disabled={loading}
        onClick={onToggle}
        onKeyDown={(e) => e.key === "Enter" && onToggle()}
      >
        CANCEL
      </button>
   
   ] : [
   
      <button
        key="edit"
        className="btn btn-text"
        onClick={onToggle}
        onKeyDown={(e) => e.key === "Enter" && onToggle()}
      >
        EDIT
      </button>,
      <button
        key="delete"
        className="btn btn-text"
        onClick={onDelete}
        onKeyDown={(e) => e.key === "Enter" && onDelete()}
      >
        DELETE
      </button>

   ];

const Name = ({ state, edit, onChange }) =>
  edit ? (
    <input
      className="form-control"
      value={state}
      onChange={onChange}
      placeholder='Name... i.e. "Sick Leave"'
      tabIndex="0"
      onKeyDown={(e) => e.key === "Enter" && e.target.blur()} // Blur on Enter
    />
  ) : (
    <div tabIndex="0">{state}</div>
  );

class Item extends React.Component {
  state = {
    loading: false,
    edit: !!this.props.data.edit,
    name: this.props.data.name
  };

  render() {
    const { loading, edit, name } = this.state;

    return (
      <tr>
        <td>
          <Name
            loading={loading}
            edit={edit}
            state={name}
            onChange={this.handlerChangeName}
          />
        </td>

        <td
          style={{ width: 200, paddingTop: edit ? 0 : 15 }}
          className="text-right"
        >
          <Actions
            edit={edit}
            loading={loading}
            onToggle={this.handlerToggle}
            onDelete={this.handlerDelete}
            onSave={this.handlerSave}
          />
        </td>
      </tr>
    );
  }

  resetState = () =>
    this.setState({
      loading: false,
      name: this.props.data.name
    });

  handlerChangeName = e => this.setState({ name: e.target.value });

  handlerToggle = () => {
    if (this.props.data.id) {
      this.setState({ edit: !this.state.edit }, this.resetState);
    } else {
      this.props.onRemove(this.props.data._id);
    }
  };

  handlerDelete = () => {
    if (!confirm("Are you sure you want to delete this shift status?")) {
      return;
    }

    this.props.onDelete(this.props.data.id, status => {
      if (!this.props.data.id && status) {
        return;
      }

      this.setState({ loading: false }, () => {
        if (status) {
          this.handlerToggle();
        }
      });
    });
  };

  handlerSave = () => {
    this.setState({ loading: true });

    const data = {
      name: this.state.name
    };

    if (this.props.data._id) {
      data._id = this.props.data._id;
    }

    this.props.onSave(this.props.data.id, data, status => {
      if (!this.props.data.id && status) {
        return;
      }

      this.setState({ loading: false }, () => {
        if (status) {
          this.handlerToggle();
        }
      });
    });
  };
}

Item.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  onRemove: PropTypes.func,
  onSave: PropTypes.func
};

export default Item;
